module.exports = {"title":"고고밴 위치정보 이용약관","tc_location_headline":"위치정보 이용약관","meta":{"keywords":"위치정보, 이용약관","description":"고고밴 - 위치정보 이용약관"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/kr/setting/tc_location/locale.json
// module id = 691
// module chunks = 0 1 2 3 4 5